import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { TablePagination } from '@mui/material';
import PropTypes from 'prop-types';

import AbEnvironment from '../auth/AbEnvironment';
import AppBindStyles from '../../AppBindStyles';
import LoadingSpinner from '../ui/LoadingSpinner';
import PageTitle from '../ui/PageTitle';
import SearchField from '../ui/SearchField';
import ServerError from '../ui/ServerError';

import AccountList from './AccountList';

const abEnvironment = new AbEnvironment();

const AccountsSearchQuery = graphql`
query AccountsQuery($accountName: String, $email: String, $accountTypes: [Int],
                $last4: String, $emailVerified: Int, $statusValues: [Int],
                $orderBy: Int, $orderDirection: Int, $first: Int, $offset: Int) {
  adminaccountsearch(accountName: $accountName, email: $email, accountTypes: $accountTypes,
                  emailverified: $emailVerified, statusvalues: $statusValues,
                  orderby: $orderBy, orderdirection: $orderDirection, 
                  last4: $last4, first: $first, offset: $offset) {
    totalCount
    ...AccountList_al
  }
}
`;

/* AccountWithLedgerSummariesConnection */

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  button: {
    marginTop: 12
  }
});

class Accounts extends Component {
  state = {
    accountName: '',
    email: '',
    last4: '',
    orderby: 1,
    orderdir: 1,
    a_appbind: false,
    a_vendor: false,
    a_distributor: false,
    a_reseller: false,
    a_customer: false,
    status_active: false,
    status_suspended: false,
    status_pending: false,
    email_verified: 1,
    page: 0,
    rowsPerPage: 10,
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    let sTerm = params.get('sterm');
    if (sTerm == null)
    {
      // Is there something in local storage?
      sTerm = localStorage.getItem('accountsSterms');
    }
    if (sTerm == null)
      sTerm = '';

    this.setState({accountName: sTerm});
  }

  goTo(route) {
    localStorage.setItem('accountsSterms', this.state.accountName);
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleCheckChange = name => event => {
    this.setState({
      [name]: event.target.checked,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  setOrderBy = (ob, dir) => {
    let thedir = dir;
    if (dir === 'asc') {
      thedir = 0;
    } else if (dir === 'desc') {
      thedir = 1;
    }
    if (thedir !== 0 && thedir !== 1) {
      thedir = 0;
    }
    this.setState({orderby: ob, orderdir: thedir, page : 0});
  }

  render() {
    const { isAuthenticated, isAuthenticatedAppBind, isAdminUser, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let theAccountSearch = '';
    if (this.state.accountName !== '')
    {
      theAccountSearch = '%' + this.state.accountName + '%';
    }
    let theEmailSearch = '';
    if (this.state.email !== '')
    {
      theEmailSearch = '%' + this.state.email + '%';
    }

    // Checkbox values are used to create the array values for account type
    let accountTypes = null;
    if (this.state.a_appbind || this.state.a_vendor || this.state.a_reseller || this.state.a_customer)
    {
      accountTypes = [];
      if (this.state.a_appbind) {
        accountTypes.push(0);
      }
      
      if (this.state.a_vendor) {
        accountTypes.push(1);
      }

      if (this.state.a_reseller) {
        accountTypes.push(3);
      }

      if (this.state.a_customer) {
        accountTypes.push(4);
      }
    }
    
    let statusValues = null;
    if (this.state.status_active || this.state.status_suspended || this.state.status_pending) {
      statusValues = [];
      if (this.state.status_active) {
        statusValues.push(0);
      }
      if (this.state.status_suspended) {
        statusValues.push(1);
      }
      if (this.state.status_pending) {
        statusValues.push(2);
      }
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedAppBind()) {
      return (
        <main>
          <PageTitle title="Accounts"/>

          <Grid container spacing={2} direction="row" justifyContent="flex-start" style={{marginBottom: 8}}>
            <Grid item>
               <SearchField
                    id="accountName"
                    label="Search by account name"
                    value={this.state.accountName}
                    onChange={this.handleChange('accountName')}
                  />

            </Grid>
            <Grid item>
              <SearchField
                    id="email"
                    label="Search by contact or user email"
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                  />
            </Grid>
            <Grid item>
              <SearchField
                    id="last4"
                    label="Search by bindcard last4"
                    value={this.state.last4}
                    onChange={this.handleChange('last4')}
                  />
            </Grid>
            { isAdminUser() &&  
            <Grid item>
              <Button 
                color="primary"
                variant="outlined"
                className={classes.button}
                onClick={this.goTo.bind(this, 'vendorcreate')}>
                Add Vendor
              </Button>
            </Grid>
            }
            { isAdminUser() && false &&
            <Grid item>
              <Button 
                color="primary"
                variant="outlined"
                className={classes.button}
                onClick={this.goTo.bind(this, 'resellercreate')}>
                Add Reseller
              </Button>
            </Grid>
            }
          </Grid>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox checked={this.state.a_appbind} onChange={this.handleCheckChange('a_appbind')} value='a_appbind' />
              }
              label="AppBind"
            />
            <FormControlLabel
              control={
                <Checkbox checked={this.state.a_vendor} onChange={this.handleCheckChange('a_vendor')} value='a_vendor' />
              }
              label="Vendor"
            />
            <FormControlLabel
              control={
                <Checkbox checked={this.state.a_reseller} onChange={this.handleCheckChange('a_reseller')} value='a_reseller' />
              }
              label="Reseller"
            />
            <FormControlLabel
              control={
                <Checkbox checked={this.state.a_customer} onChange={this.handleCheckChange('a_customer')} value='a_customer' />
              }
              label="Customer"
            />
          </FormGroup>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox checked={this.state.status_active} onChange={this.handleCheckChange('status_active')} value='status_active' />
              }
              label="Active"
            />
            <FormControlLabel
              control={
                <Checkbox checked={this.state.status_suspended} onChange={this.handleCheckChange('status_suspended')} value='status_suspended' />
              }
              label="Suspended"
            />
            <FormControlLabel
              control={
                <Checkbox checked={this.state.status_pending} onChange={this.handleCheckChange('status_pending')} value='status_pending' />
              }
              label="Pending"
            />
          </FormGroup>
          <FormControlLabel
              control={
                <Checkbox checked={ this.state.email_verified === 1 }
                  value='email_verified'
                  onChange={(e) => {this.setState({ email_verified: e.target.checked ? 1 : 0, page: 0})}}/>
              }
              label="Reseller email verified"
            />
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={AccountsSearchQuery}
            variables={{accountName: theAccountSearch,
                        email: theEmailSearch,
                        last4: this.state.last4,
                        accountTypes: accountTypes,
                        orderBy: this.state.orderby,
                        orderDirection: this.state.orderdir,
                        emailVerified: this.state.email_verified,
                        statusValues: statusValues,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.adminaccountsearch.totalCount;

                return ( 
                  <div>
                    <AccountList al={props.adminaccountsearch} 
                                 auth={this.props.auth}
                                 orderBy={this.state.orderby}
                                 orderDirection={this.state.orderdir}
                                 setOrderBy={this.setOrderBy}
                                 sterm={this.state.accountName} history={this.props.history}/>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

Accounts.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Accounts);
